import { IsString } from "class-validator"

export class Attachment {
  @IsString()
  name: string
}
